export class Tenants {
  public static readonly Rewards4Racing = "rewards4racing";
  public static readonly Rewards4RacingIreland = "rewards4racingie";
  public static readonly Rewards4Imps = "rewards4imps";
  public static readonly Rewards4Golf = "rewards4golf";
  public static readonly Rewards4Tigers = "rewards4tigers";
  public static readonly Rewards4Wolves = "rewards4wolves";
  public static readonly Rewards4LancashireCricket = "rewards4lancashirecricket";
  public static readonly Rewards4AffordableGolf = "rewards4affordablegolf";
  public static readonly Rewards4RugbyLeague = "rewards4rugbyleague";
  public static readonly Rewards4Sport = "rewards4sport";
}